<template>
  <div>
    <vs-popup :title="popupTitle" :active.sync="showModal" id="menu-popup">
      <form v-if="showModal">
        <div class="flex flex-col gap-2">
          <div class="w-full flex flex-col">
            <vs-input
              v-model="model.title"
              name="title"
              :label="$t('Title')"
              v-validate="'required'"
            />
            <span class="text-danger text-sm" v-show="errors.has('title')">{{
              errors.first("title")
            }}</span>
          </div>
          <div class="w-full flex flex-col">
            <vs-input
              v-model="model.subTitle"
              name="subtitle"
              :label="$t('Subtitle')"
            />
          </div>
          <div class="flex gap-2">
            <div class="flex-grow flex flex-col">
              <vs-input
                v-model="model.name"
                name="name"
                :label="$t('Name')"
                v-validate="'required'"
              />
              <span class="text-danger text-sm" v-show="errors.has('name')">{{
                errors.first("name")
              }}</span>
            </div>
            <div class="flex-grow flex flex-col">
              <vs-input
                v-model="model.priority"
                name="priority"
                :label="$t('Priority')"
              />
            </div>
          </div>
          <div class="w-full flex">
            <vs-textarea
              v-model="model.description"
              name="description"
              :label="$t('Description')"
            />
          </div>
        </div>

        <vs-button
          type="filled"
          class="float-right my-4"
          @click.prevent="submitForm"
          >{{ $t("Save") }}</vs-button
        >
      </form>
    </vs-popup>
  </div>
</template>

<style lang="scss">
.removeIco {
  float: left !important;
  top: 10px !important;
  left: 10px !important;
}
</style>

<script>
import { URLS_CONSTANTS } from "../../../../config";
import { mapActions } from "vuex";
import { Validator } from "vee-validate";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";

const dict = {
  custom: {
    title: {
      required: "لطفا عنوان را وارد نمایید.",
    },
    name: {
      required: "لطفا نام را وارد نمایید.",
    },
  },
};
Validator.localize("fa", dict);
export default {
  name: "Content_management_Menus_ModifyPopup",
  props: {
    show: { default: false },
    modelToEdit: { default: null },
  },
  data() {
    return {
      popupTitle: "",
      clearable: true,
      showUpload: false,
      searchQueryNew: "",
      searchQueryOld: "",
      URLS_CONSTANTS: URLS_CONSTANTS,
      model: {
        title: "",
        subTitle: "",
        name: "",
        priority: "",
        description: "",
      },
    };
  },
  computed: {
    showModal: {
      get: function () {
        return this.show;
      },
      set: function () {
        this.$emit("close");
      },
    },
  },
  methods: {
    ...mapActions({
      createContent: "contentType/createContent",
      editContent: "contentType/editContent",
    }),
    resetModel() {
      this.model = {
        title: "",
        subTitle: "",
        name: "",
        priority: "",
        description: "",
      };
    },
    submitForm() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          if (this.modelToEdit && this.modelToEdit.id) {
            this.editContent(this.model).then((response) => {
              if (response) {
                this.$swal({
                  position: "center-center",
                  type: "success",
                  text: "رکورد مورد‌نظر با موفقیت ثبت شد!",
                  showConfirmButton: false,
                  timer: 2000,
                });
                this.$emit("finish");
                this.resetModel();
                this.$validator.reset();
              }
            });
          } else {
            this.createContent(this.model).then((response) => {
              if (response) {
                this.$swal({
                  position: "center-center",
                  type: "success",
                  text: "رکورد مورد‌نظر موفقیت ثبت شد!",
                  showConfirmButton: false,
                  timer: 2000,
                });
                this.$emit("finish");
                this.resetModel();
                this.$validator.reset();
              }
            });
          }
        }
      });
    },
  },
  watch: {
    show() {
      this.$validator.reset();
      if (this.show) {
        this.$validator.resume();
      } else {
        this.$validator.pause();
      }
      if (this.show && this.modelToEdit.id) {
        this.popupTitle = "ویرایش محتوا: " + this.modelToEdit.title;
        this.model = this.modelToEdit;
      } else {
        this.resetModel();
        this.popupTitle = this.$t("CreateNewContent");
      }
    },
  },
};
</script>
